import React, { Component } from "react";
import ReactDOM from "react-dom";
import cn from "classnames";
import Layout from "../Layout";
import "./HorizontalAdaptLayout.less";
import FillLayout from "../fill/FillLayout";

const CLASS_NAME = "fct-horizontal-adapt-layout";
const VERTICAL_ALIGN = {
  TOP: "_top",
  MIDDLE: "_middle",
  BOTTOM: "_bottom",
  STRETCH: "_stretch"
};

class HorizontalAdaptLayout extends Component {
  static defaultProps = {
    restrict: true, // 是否限制宽不会溢出
    scrollx: true,
    verticalAlign: VERTICAL_ALIGN.TOP
  };

  _renderNoRestrict() {
    const {
      children,
      restrict,
      verticalAlign,
      className,
      ...props
    } = this.props;
    return (
      <Layout className={cn(CLASS_NAME, verticalAlign, className)} {...props}>
        {React.Children.map(children, child => {
          return (
            child &&
            React.cloneElement(child, {
              className:
                child.props.width > 0
                  ? cn("layout-item", child.props.className)
                  : cn("layout-item", "layout-full-item", child.props.className)
            })
          );
        })}
      </Layout>
    );
  }

  _renderRestrict() {
    const {
      children,
      restrict,
      verticalAlign,
      scrollx,
      className,
      ...props
    } = this.props;
    let allWidth = 0;
    React.Children.forEach(children, child => {
      if (child) {
        allWidth += child.props.width || 0;
      }
    });
    return (
      <Layout
        className={cn(CLASS_NAME, verticalAlign, className)}
        {...props}
      >
        {React.Children.map(children, child => {
          return (
            child &&
            React.cloneElement(child, {
              ...(child.props.width > 0
                ? {}
                : {
                    style: {
                      ...child.props.style,
                      width: `calc(100% - ${allWidth}px)`
                    }
                  })
            })
          );
        })}
      </Layout>
    );
  }

  render() {
    return this.props.restrict
      ? this._renderRestrict()
      : this._renderNoRestrict();
  }
}

HorizontalAdaptLayout.Item = FillLayout;
HorizontalAdaptLayout.VERTICAL_ALIGN = VERTICAL_ALIGN;
export default HorizontalAdaptLayout;



// WEBPACK FOOTER //
// ./layout/adapt/HorizontalAdaptLayout.js